module.exports = __webpack_public_path__ + "static/media/Screenshot_5-thumb.bb1a840d.png";